module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('v-card', {
    staticClass: "mx-3 mb-3"
  }, [_c('v-card-title', {
    staticStyle: {
      "background-color": "#424242",
      "color": "#fff"
    },
    attrs: {
      "dark": ""
    }
  }, [_c('v-layout', [_vm._v("\n          Invite User\n          ")])], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.inviteUser.apply(null, arguments)
      }
    }
  }, [_c('v-card-text', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "text-field m",
    attrs: {
      "type": "text",
      "placeholder": "Insert user's email address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-0 pt-0",
    staticStyle: {
      "padding-left": "16px"
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "color": "primary"
    }
  }, [_vm._v("Invite")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e70b63ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/grouppage/inviteUser.vue
// module id = 1731
// module chunks = 17